import React,{useState} from "react";
import { PropTypes } from 'prop-types';
import { connect } from "react-redux";
import {
  StepHead,
  MiniContent,
  SelectWrap,
  PrimaryButton,
  LinkStyle,
  UnderLine,
  StepSubHead
} from "./styles";
import {
  PagesHeadingWrapper,
  ContentContainerSpace
} from "../Step1Setup/styles";
import { SubHeadSpace } from "../AccountCreated/styles";
import SelectComponent from "../Step2LegacyOptions/Components/SelectComponent";
import { setEstimateInitialContribution } from "../actions";
import { getpwUrl } from "../../../../utils/commonUtil";

export const ContributeLater = props => {
  
  const [selected, setSelected] = useState("-Select-");
  const [dropDownData, setdropDownData] = useState(props.dollarPotential ? props.dollarPotential : []);
  let count = 0;
  let stepContent = [
    {
      step: "Step1",
      content: "Log in to your vanguardcharitable.org account."
    },
    {
      step: "Step2",
      content:
        'Click on "Contribute To Account" and follow the prompts for the type of asset you plan to donate.'
    },
    {
      step: "Step3",
      content:
        "Depending on the asset, specific instructions are provided, such as how to link to Vanguard account, initiate transfer, send check with remittance slip, or wire funds."
    }
  ];
  
  const handleChange = desc => {
    let codeIddata = dropDownData.find(res => res.desc === desc);
    let requestBody = {
      codeId: codeIddata ? codeIddata.value : undefined,
      codeType: "DOLLAR_POTENTIAL",
      codeValue: desc
    }
    setSelected(desc);
    props.setEstimateInitialContribution(requestBody);
  };
  
  const goToNextStep = () => {
    props.history.push("/");
  };
  return (
		<div>
			<ContentContainerSpace>
				<div className="fluid">
					<LinkStyle role="navigation" aria-expanded="false" data-test="breadcrumb-component">
						<span>Home</span> <span>></span> <span>Open account</span>
					</LinkStyle>
					<PagesHeadingWrapper role="heading" aria-level="1" aria-expanded="false" data-test="contribute-later-title">Contribute to account later</PagesHeadingWrapper>
					<SubHeadSpace marginBottom="50px" mobileMarginBottom="40px"  data-test="contribute-later-desc">
            We understand that you may need time to make a contribution. 
            When you're ready, log into your account to make a contribution. 
            Are you a Vanguard client? Learn how to contribute from your Vanguard account by visiting our&nbsp;
						<a href={getpwUrl() + "/FAQs"} target="_blank">
							<UnderLine>FAQs</UnderLine>.
						</a>
					</SubHeadSpace>
					{stepContent.map((val,iteration) => {
						count = count + 1;
						return (
							<div key={iteration+1}  data-test="contribute-later-steps">
								<StepHead>{val.step}</StepHead>
								{count === 3 ? (
									<SubHeadSpace marginBottom="50px" mobileMarginBottom="40px">
										<StepSubHead contentWidth="910px" mWidth="276px">
											{val.content}
										</StepSubHead>
									</SubHeadSpace>
								) : (
									<SubHeadSpace marginBottom="30px" mobileMarginBottom="20px">
										<StepSubHead contentWidth="910px" mWidth="276px">
											{val.content}
										</StepSubHead>
									</SubHeadSpace>
								)}
							</div>
						);
					})}
					<MiniContent data-test="contribute-later-estimate">Estimated Initial Contribution (Optional)</MiniContent>
					<SelectWrap>
						<SelectComponent
              id="estimateContribution"
              dataTest="contributeLater-select"
							placeholder="-Select-"
							showArrow={true}
							data={dropDownData}
							handleInputChange={desc => handleChange(desc)}
							value={selected}
						/>
					</SelectWrap>
					<PrimaryButton data-test="contributeLater-btn" onClick={e => goToNextStep()}>view account</PrimaryButton>
				</div>
			</ContentContainerSpace>
		</div>
  );
};

const mapStateToProps = state => ({
  dollarPotential: state.getIn([
    "npaFormReducer",
    "dropdownValues",
    "data",
    "dollarPotential"
  ])
});

const mapDispatchToProps = dispatch => ({
  setEstimateInitialContribution: val => dispatch(setEstimateInitialContribution(val))
});

ContributeLater.propTypes = {
  dollarPotential: PropTypes.any,
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  setEstimateInitialContribution: PropTypes.func,
  staticContext: PropTypes.any,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContributeLater);
